import { render, staticRenderFns } from "./CallAnalysisDashboard.vue?vue&type=template&id=020b9c77&scoped=true"
import script from "./CallAnalysisDashboard.vue?vue&type=script&lang=js"
export * from "./CallAnalysisDashboard.vue?vue&type=script&lang=js"
import style0 from "./CallAnalysisDashboard.vue?vue&type=style&index=0&id=020b9c77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020b9c77",
  null
  
)

export default component.exports